
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { dateToSeconds, getSystemDate, pickerOptions } from '@/utils/dateTime'
import { getTransaction } from '@/api/market/market'
import { AppModule } from '@/store/modules/app'
import axios from 'axios'

@Component({
  name: 'fund',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private appItem!: any

  private queryForm: any = {
    start_time: null,
    end_time: null,
    order_number: '',
    cause: '',
    balance_type: 'balance'
  }

  private date: any[] = getSystemDate()
  private pickerOptions = pickerOptions
  private listLoading: boolean = false
  private list: any[] = []
  private total = 0

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      start_time: null,
      end_time: null,
      order_number: '',
      balance_type: 'balance'
    }
    this.currentPage = 1
    // this.date = getOneDate()
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  // 标签分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }
  // 标签分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 获取全部应用列表
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      await axios({
        url: this.development
          ? 'https://dapi.zolopay.com/api/manage/open-transaction'
          : 'https://dapi.paypptp.com/api/manage/open-transaction',
        method: 'get',
        params: {
          ...this.queryForm,
          enterprise_plugin: this.appItem.enterprise_plugin,
          page_size: this.pagesize,
          page: this.currentPage
        }
      }).then((res: any) => {
        this.list = res.data.results
        this.total = res.data.count
        this.listLoading = false
      })
    } catch (error) {
      this.$message.error(error.response.data.message)
      this.listLoading = false
    }
  }
  private development: boolean = true
  mounted() {
    AppModule.SetCurrentCurrencyType(this.appItem.currency)
    if (
      window.location.origin === 'https://manage.zolopay.com' ||
      window.location.hostname === 'localhost'
    ) {
      // 测试环境的处理逻辑
      this.development = true
    } else {
      // 正式环境的处理逻辑
      this.development = false
    }
    this.hadleGetFilesListApi()
  }
}
